<template>
    <div class="flex items-center border-b p-4 hover:bg-gray-100 cursor-pointer">
        <div class="flex items-center flex-1">
            <div
                class="text-white text-xs uppercase rounded-full w-8 h-8 flex items-center justify-center"
                :style="{ background: favored.bgItemList }"
            >
                {{ favored.initialsName }}
            </div>
            <div class="ml-3">
                <div class="uppercase text-sm leading-4">
                    {{ favored.name }}
                </div>
                <small class="text-gray-500 block text-xs">
                    {{ favored.key || favored.document }}
                </small>
            </div>
        </div>
        <slot name="action"></slot>
    </div>
</template>

<script>
export default {
    name: 'Favored',
    props: {
        favored: { type: Object, required: true }
    }
}
</script>
